import Unauthorized from '@/auth/Unauthorized';
import { useAuth } from '@/context/AuthContext';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/unauthorized')({
  component: RouteComponent,
})

function RouteComponent() {
    const auth = useAuth();
  
  // Redirigir a login si no está autenticado
  if (!auth.isAuthenticated && !auth.loading) {
    window.location.href = '/login';
    return null;
  }
  return (
    <Unauthorized/>
  )
}
